import React, { useEffect, useState } from 'react';
import API from '../../api/api';
import { useUser } from '../../context/UserContext';
import CouponManagement from './CouponManagement';

interface Subscription {
    userId: string;
    status: string;
    paymentFrequency: string;
    paymentAmount: number;
    lastPaymentDate: string;
    startDate: string;
    endDate: string;
    missedPaymentPeriods: number;
    overDueAmount: number;
    totalAmountSpent: number;
}

const SubscriptionPage: React.FC = () => {
    const [subscription, setSubscription] = useState<Subscription | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { user } = useUser();

    useEffect(() => {
        const fetchSubscription = async () => {
            try {
                // Remove JSON.parse() since token is already a string
                const token = localStorage.getItem("token") || '';
                
                // Only make the request if we have a token
                if (!token) {
                    setError("Authentication required");
                    setLoading(false);
                    return;
                }

                const response = await API.get(`/subscription`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.status === 200) {
                    setSubscription(response.data);
                } else {
                    setError("Failed to load subscription data.");
                }
            } catch (err: any) {
                console.error("Error fetching subscription data:", err);
                setError(err?.response?.data?.message || "An error occurred while fetching subscription data.");
            } finally {
                setLoading(false);
            }
        };

        fetchSubscription();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (!subscription) {
        return <div>No subscription data available.</div>;
    }

    return (
        <div className="container mt-4">
             {user?.role === "admin" && 
            <CouponManagement /> }
            {user?.role === "client" && (
                <div className="card">
                    <div className="card-header">
                        <h2 className="mb-0">Subscription Details</h2>
                    </div>
                    <div className="card-body">
                        <div className="list-group">
                            <p className="list-group-item"><strong>Status:</strong> {subscription.status}</p>
                            <p className="list-group-item"><strong>Frequency:</strong> {subscription.paymentFrequency || "N/A"}</p>
                            <p className="list-group-item"><strong>Amount:</strong> RWF {subscription.paymentFrequency === "coupon" ? "N/A" : subscription?.paymentAmount?.toFixed(2)}</p>
                            <p className="list-group-item"><strong>Start Date:</strong> {new Date(subscription.startDate).toLocaleDateString()}</p>
                            <p className="list-group-item"><strong>End Date:</strong> {new Date(subscription.endDate).toLocaleDateString()}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionPage;